var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hero__typewriter",attrs:{"data-testid":"typewritter"}},[_c('h1',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.splitTitle[0])+" "),_c('br'),_vm._v(" "),_c('span',{ref:"hero__word-box",staticClass:"hero__word-box"}),_vm._v(" "),_c('br'),_vm._v("\n    "+_vm._s(_vm.splitTitle[1])+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }